module.exports = __webpack_public_path__ + "img/scene_ops.879191c9.webp";